import { render } from "./FlagLabel.vue?vue&type=template&id=d90dbb74"
import script from "./FlagLabel.vue?vue&type=script&lang=js"
export * from "./FlagLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__